// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2MiBp","colMin":"styles_colMin__3RBrx","colCheckbox":"styles_colCheckbox__lexDK"};